'use client';

import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Box, Card, CardActions, CardContent, Container, GridLegacy as Grid, Link as MuiLink, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
export default function Stats({
  statsObj
}: {
  statsObj: {
    title: string;
    stats: Array<{
      value: string;
      description: string;
      url: string;
      label: string;
    }>;
  };
}) {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  return <Box sx={{
    bgcolor: 'background.default',
    py: {
      xs: 1
    }
  }} data-sentry-element="Box" data-sentry-component="Stats" data-sentry-source-file="Stats.tsx">
      <Container maxWidth="lg" data-sentry-element="Container" data-sentry-source-file="Stats.tsx">
        <Typography variant={isSm ? 'h4' : 'h3'} component="h3" fontWeight={800} textAlign="center" gutterBottom sx={{
        mb: {
          xs: 4,
          md: 6
        }
      }} data-sentry-element="Typography" data-sentry-source-file="Stats.tsx">
          {statsObj.title}
        </Typography>

        <Grid container spacing={4} data-sentry-element="Grid" data-sentry-source-file="Stats.tsx">
          {statsObj.stats.map(({
          value,
          description,
          url,
          label
        }) => <Grid item key={label} xs={12} sm={6} lg={3}>
              <Card elevation={1} sx={{
            'height': '100%',
            'border': `1px solid ${theme.palette.divider}`,
            'borderRadius': 2,
            'display': 'flex',
            'flexDirection': 'column',
            'transition': 'transform 0.2s, box-shadow 0.2s',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: 4
            }
          }}>
                <CardContent sx={{
              textAlign: 'center',
              flexGrow: 1,
              px: 3,
              pt: 4
            }}>
                  <TrendingUpIcon color="primary" sx={{
                fontSize: 40,
                mb: 1
              }} />
                  <Typography variant={isSm ? 'h3' : 'h2'} color="primary" fontWeight={700} gutterBottom component="div">
                    {value}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{
                lineHeight: 1.5,
                mt: 2,
                // optional clamp for very long text:
                display: '-webkit-box',
                WebkitLineClamp: 4,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}>
                    {description}
                  </Typography>
                </CardContent>

                <CardActions sx={{
              justifyContent: 'center',
              pb: 2
            }}>
                  <MuiLink href={url} target="_blank" rel="noopener noreferrer" underline="hover" color="text.secondary" sx={{
                fontSize: '0.875rem'
              }}>
                    Source:
                    {' '}
                    {label}
                  </MuiLink>
                </CardActions>
              </Card>
            </Grid>)}
        </Grid>
      </Container>
    </Box>;
}